'use strict';

var React = require('react'),
    { reject } = require('underscore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    StampStore = require('../stores/StampStore'),
    ImageStore = require('../stores/ImageStore'),
    ImageActionCreators = require('../actions/ImageActionCreators'),
    Group = require('../organisms/Group'),
    SidebarBody = require('../organisms/SidebarBody'),
    EmptyState = require('../molecules/EmptyState'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ImageUsedInStampStore = require('../stores/ImageUsedInStampStore'),
    { PropTypes } = React;

var ImageUsedInStamps = React.createClass({
  mixins: [createStoreMixin(ImageUsedInStampStore, ImageStore, StampStore), PureRenderMixin],

  propTypes: {
    imageUuid: PropTypes.string.isRequired,
    excludeStampId: PropTypes.number
  },

  getStateFromStores(props) {
    var image = ImageStore.get(props.imageUuid),
        usedInStamps = ImageUsedInStampStore.getStamps(props.imageUuid);

    return {
      image: image,
      usedInStamps: reject(usedInStamps, s => s.id === props.excludeStampId)
    };
  },

  componentDidMount() {
    var { imageUuid } = this.props;
    ImageActionCreators.requestImageUsedInStampsPage(imageUuid, true);
  },

  render() {
    var { imageUuid } = this.props,
        { usedInStamps } = this.state;

    return (
      <SidebarBody title='More Stamps with This Image'
                   subtitle=''>
        <Group type='stamps'
               context='Sidebar'
               mode='grid'
               columns={2}
               isExpectingPage={ImageUsedInStampStore.isExpectingPage(imageUuid)}
               isLastPage={ImageUsedInStampStore.isLastPage(imageUuid)}
               isInvalidated={ImageUsedInStampStore.isInvalidated(imageUuid)}
               loadNextPage={this.requestNextPendingPage}
               items={usedInStamps}
               itemProps={{
                size: 'small',
                routeName: 'feedStamp',
                showZine: false,
                routeParams: {
                  imageUuid: imageUuid
                }
              }}>
          <EmptyState label='There are no other stamps with this image.'
                      context='Sidebar'
                      absoluteCenter />
        </Group>
      </SidebarBody>
    );
  },

  requestNextLatestPage() {
    var { imageUuid } = this.props;
    ImageActionCreators.requestImageUsedInStampsPage(imageUuid);
  }
});

module.exports = ImageUsedInStamps;



/** WEBPACK FOOTER **
 ** ./sidebar/ImageUsedInStamps.jsx
 **/